<template>
  <ContentCard title="用户登录" rightTitle="快速注册" @rightClick="goRegestPage">
    <div class="login-content">
			<div @click="goLoginPage('gys')">
				<img src="@/config/images/sign-supplier.png" />
				<span>供应商</span>
			</div>
			<div @click="goLoginPage('dljg')">
				<img src="@/config/images/sign-institution.png" />
				<span>代理机构</span>
			</div>
			<div @click="goLoginPage('zj')">
				<img src="@/config/images/sign-expert.png" />
				<span>专家</span>
			</div>
      <div @click="goLoginPage('cgr')">
				<img src="@/config/images/sign-purchaser.png" />
				<span>采购人</span>
			</div>
      <!-- <div @click="goLoginPage('jdry')">
				<img src="@/config/images/sign-purchaser.png" />
				<span>监督人员</span>
			</div> -->
    </div>
  </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard'
import { encrypt } from '@/utils/crypt'

export default {
	name: "toLogin",
  components: { ContentCard },
  computed: {
    tenantId() {
      return window.urlConfig.web.tenantId
    }
  },
	methods: {
		goLoginPage(type) {
      window.location.href = `${window.urlConfig.sources.mainUrl}/basic/home/?role=${type}`
		},
    goRegestPage() {
      const tenantIdData = `td=${encrypt(this.tenantId)}`
      window.location.href = `${window.urlConfig.sources.mainUrl}/basic/login/register?${tenantIdData}`
    }
	}
};
</script>

<style lang="less" scoped>
.login-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 188px;
  padding: 16px;
  background-color: #0E8FA5;
  > div {
    display: flex;
    align-items: center;
    width: 48%;
    border: 1px dashed #fff;
    background-color: #2ca7bd;
    cursor: pointer;
    margin-bottom: 16px;
    > img {
      width: 40px;
      height: 40px;
      margin: 0 10px;
    }
    > span {
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
